import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Level } from '@/modules/settings/levels/types/types.ts'

export type LevelState = {
  selected?: Level
  isOpenModal: boolean
}

const initialState: LevelState = {
  selected: undefined,
  isOpenModal: false
}

const levelSlice = createSlice({
  name: 'levels',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<Level | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    }
  }
})

export const levelsActions = levelSlice.actions
export const { reducer: levelsReducer } = levelSlice
